var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
export default SvgCheckmarkCircle;